import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=bcd3ba78&"
import script from "./CategoryForm.vue?vue&type=script&lang=js&"
export * from "./CategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports